export enum Purpose {
    REFINANCE = 'Refinance',
    REFINANCE_AND_EXTRA_MONEY = 'RefinanceAndExtraMoney',
    EXTRA_MONEY = 'ExtraMoney',
    BUY_NEW_PROPERTY = 'BuyNewProperty',
    BETTER_LOAN_TERMS = 'BetterLoanTerms'
}